export function mergeProps(stateProps, dispatchProps, ownProps) {
  let fetched;
  if (
    typeof stateProps.fetched === "undefined" &&
    typeof ownProps.fetched !== "undefined"
  )
    fetched = ownProps.fetched;
  if (
    typeof stateProps.fetched !== "undefined" &&
    typeof ownProps.fetched === "undefined"
  )
    fetched = stateProps.fetched;
  if (
    typeof stateProps.fetched !== "undefined" &&
    typeof ownProps.fetched !== "undefined"
  ) {
    fetched = ownProps.fetched && stateProps.fetched;
  }

  return { ...stateProps, ...dispatchProps, ...ownProps, fetched };
}
